module.exports = __webpack_public_path__ + "img/mobile-chat.59400375.svg";